import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import  styles from "./dell.module.css";
import Head from "next/head";
import Image from 'next/image';
import Upsdelhibanner from "../../assets/images/upsc/UPSC-Mentorship-Programme-Web-Banner.jpg";
import MobUpscdelhibanner from "../../assets/images/upsc/UPSC-Mentorship-Programme-Mob-Banner.jpg";
// import Calendar from "../../assets/images/icon/Calender-01.png"; 
// import Clock from "../../assets/images/icon/clock-01.png";
import Group from "../../assets/images/upsc/Group.png";
import Calendar from "../../assets/images/upsc/Calendar-Icon.png";
import Clock from "../../assets/images/upsc/Clock-Icon.png";


export default function index() {

  return (
    <>
    <Head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="index,follow" />
        <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>Best UPSC Mentorship Programme for IAS & UPSC Aspirants</title>
        <meta name="title" content="Best UPSC Mentorship Programme for IAS & UPSC Aspirants" />
        <meta name="description" content="Join our UPSC Mentorship Programme for personalised guidance, expert mentorship, study strategies, answer writing and comprehensive UPSC preparation support." />
        <link rel="canonical" href="https://www.shankariasacademy.com/upsc-mentorship-programme/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best UPSC Mentorship Programme for IAS & UPSC Aspirants" />
        <meta property="og:description" content="Join our UPSC Mentorship Programme for personalised guidance, expert mentorship, study strategies, answer writing and comprehensive UPSC preparation support." />
        <meta property="og:url" content="https://www.shankariasacademy.com/upsc-mentorship-programme/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
    </Head>

    <Navbar />

    <div className="container pt-3 ">
        <div className="rows pt-3 pb-3">
            <h1 className={`${styles.sectiontitle}`}>Integrated UPSC Prelims and Mains Mentorship Programme - 2026</h1>
        </div>
    </div>

    <div className="container">
      <div className="row d-none d-md-block">
          <div className="col mb-3">
            <Image
              src={Upsdelhibanner}
              alt="orientation banner"
              title="UPSC orientation Test Series 2024"
              className="img-fluid w-100"
            />
          </div>
      </div>

      <div className="row d-block d-md-none">
        <div className="col mb-3">
          <Image
            src={MobUpscdelhibanner}
            alt="orientation banner"
            title="UPSC orientation"
            className="img-fluid w-100"
          />
        </div>
      </div>
    </div>

     <section className={`${styles.programSection} py-4 py-lg-5`}>
      <div className="container">

        {/* Programme Info Cards */}
        <div className="row g-3">

          {/* Start Date */}
          <div className="col-12 col-md-6 col-xl-3">
            <div className={`${styles.infoCard} h-100`}>
              <div className="row align-items-center">
                <div className="col-8">
                  <span className={styles.label}>Commencement</span>

                  <div className={styles.date}>
                    15<sup>th</sup>
                  </div>

                  <span className={styles.subText}>
                    October 2026
                  </span>
                </div>

                <div className="col-4 text-end">
                  <div className={styles.numberIcon}>
                    <Image
                    src={Calendar}
                    alt="Programme timing"
                    width={42}
                    height={42}
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Timing */}
          <div className="col-12 col-md-6 col-xl-3">
            <div className={`${styles.infoCard} h-100`}>
              <div className="row align-items-center">
                <div className="col-8">
                  <span className={styles.label}>Timings</span>

                  <div className={styles.time}>
                    02:30 PM
                  </div>

                  <span className={styles.subText}>
                    to 04:30 PM
                  </span>
                </div>

                <div className="col-4 text-end">
                 <div className={styles.numberIcon}>
                    <Image
                    src={Clock}
                    alt="Programme timing"
                    width={42}
                    height={42}
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sessions */}
          <div className="col-12 col-md-6 col-xl-3">
            <div className={`${styles.infoCard} h-100`}>
              <div className="row align-items-center">
                <div className="col-8">
                  <span className={styles.label}>Total Sessions</span>

                  <div className={styles.date}>
                    13
                  </div>

                  <span className={styles.subText}>
                    Expert-led sessions
                  </span>
                </div>

                <div className="col-4 text-end">
                  <div className={styles.numberIcon}>
                    <Image
                    src={Group}
                    alt="Programme timing"
                    width={42}
                    height={42}
                  />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Fee */}
          <div className="col-12 col-md-6 col-xl-3">
            <div className={`${styles.infoCard} h-100`}>
              <div className="row align-items-center">
                <div className="col-7">
                  <span className={styles.label}>Programme Fee</span>

                  <div className={styles.fee}>
                    ₹7,000
                  </div>

                  <span className={styles.subText}>
                    Incl. of Tax
                  </span>
                </div>

                <div className="col-5 ">
                  <a
                    href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=NIPUNA (INTEGRATED MENTORSHIP PROGRAMME)"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.payButton}
                  >
                    Pay Now
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Programme Overview */}
        <div className="row mt-4 mt-lg-5 align-items-center">

          <div className="col-12 col-lg-7">
            <div className={styles.overviewBox}>

              <span className={styles.sectionTag}>
                NIPUNA PROGRAMME
              </span>

              <h2 className={styles.heading}>
                Integrated UPSC Mentorship Programme
              </h2>

              <p className={styles.description}>
                NIPUNA aims to bridge the gap between preparation and
                examination performance by helping aspirants understand
                <strong> what to study, how to think, how to approach
                UPSC questions, and how to present answers effectively.</strong>
              </p>

              <p className={styles.description}>
                The programme focuses on developing the right strategy,
                analytical skills, answer-writing ability and confidence
                required to excel in both <strong>UPSC Prelims and Mains.</strong>
              </p>

            </div>
          </div>

          {/* Coverage */}
          <div className="col-12 col-lg-5 mt-4 mt-lg-0">
            <div className={styles.coverageCard}>

              <div className={styles.coverageTitle}>
                Programme Coverage
              </div>

              <div className="row g-3">

                <div className="col-6">
                  <div className={styles.coverageItem}>
                    <span className={styles.coverageNumber}>
                      Prelims
                    </span>
                    <span className={styles.coverageText}>
                      Strategy & Practice
                    </span>
                  </div>
                </div>

                <div className="col-6">
                  <div className={styles.coverageItem}>
                    <span className={styles.coverageNumber}>
                      Mains
                    </span>
                    <span className={styles.coverageText}>
                      Answer Writing
                    </span>
                  </div>
                </div>

                <div className="col-6">
                  <div className={styles.coverageItem}>
                    <span className={styles.coverageNumber}>
                      Essay
                    </span>
                    <span className={styles.coverageText}>
                      Expert Guidance
                    </span>
                  </div>
                </div>

                <div className="col-6">
                  <div className={styles.coverageItem}>
                    <span className={styles.coverageNumber}>
                      Ethics
                    </span>
                    <span className={styles.coverageText}>
                      Answer Approach
                    </span>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

          <div className={`${styles.scheduleBox} mt-4 mt-lg-5`}>

          <div>
            <span className={styles.scheduleTag}>
              13 SESSIONS
            </span>

            <h2>
              Detailed Session Schedule
            </h2>

            <p>
              Explore the complete session schedule and understand the
              topics and learning areas covered in the NIPUNA programme.
            </p>
          </div>

          <a
            href="https://shankariasacademy.com/pdf/upsc-mentorship-programme.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.scheduleButton}
          >
            View Schedule
          </a>

        </div>

        {/* Key Features */}
        <div className="row mt-4 mt-lg-5">

          <div className="col-12 text-center mb-4">
            <span className={styles.sectionTag}>
              WHY NIPUNA?
            </span>

            <h2 className={styles.featureHeading}>
              What You Will Learn
            </h2>

            <p className={styles.featureIntro}>
              Develop the strategy, analytical ability and answer-writing
              skills required to approach the UPSC examination effectively.
            </p>
          </div>

          {/* Feature 1 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>01</span>
              <h3>Integrated Preparation</h3>
              <p>
                Prepare strategically for both UPSC Prelims and Mains
                through an integrated approach.
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>02</span>
              <h3>Expert Mentorship</h3>
              <p>
                Receive expert-led guidance to build an effective UPSC
                preparation strategy.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>03</span>
              <h3>Understand UPSC Demand</h3>
              <p>
                Understand the UPSC question pattern, examination demand
                and effective question approach.
              </p>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>04</span>
              <h3>Analytical Thinking</h3>
              <p>
                Develop analytical and critical-thinking skills needed
                to tackle complex UPSC questions.
              </p>
            </div>
          </div>

          {/* Feature 5 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>05</span>
              <h3>Mains Answer Writing</h3>
              <p>
                Learn how to structure answers with effective introductions,
                analysis and conclusions.
              </p>
            </div>
          </div>

          {/* Feature 6 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>06</span>
              <h3>Current Affairs Integration</h3>
              <p>
                Learn how to use relevant current affairs effectively
                in Mains answers.
              </p>
            </div>
          </div>

          {/* Feature 7 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>07</span>
              <h3>Essay & Ethics</h3>
              <p>
                Get focused guidance for approaching Essay and Ethics
                questions effectively.
              </p>
            </div>
          </div>

          {/* Feature 8 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>08</span>
              <h3>Prelims Analysis</h3>
              <p>
                Analyse Prelims question patterns and improve your
                approach through targeted practice.
              </p>
            </div>
          </div>

          {/* Feature 9 */}
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div className={styles.featureCard}>
              <span className={styles.featureNumber}>09</span>
              <h3>Performance Guidance</h3>
              <p>
                Focus on personalised practice and performance-oriented
                preparation.
              </p>
            </div>
          </div>

        </div>

        {/* Schedule CTA */}
      
      </div>
    </section>

   

    <Footer />
    </>
  )
}
